import React from "react";
import "./mobileView.css";
import MobileViewData from "./MobileViewData";

function MobileView({data,mobileWidth}) {
  return (
  
        <div style={{ backgroundColor: "white"}}>
          <div
            style={{
              width: mobileWidth ? `${mobileWidth}` : '30%',
              border: "1px solid #eee",
              margin: "auto",
              height: "100vh",
              background: "#ffffff",
              padding: "8px 20px 25px 20px",
              overflowY: "scroll",
              WebkitOverflowScrolling: "hidden",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "100%",
                gap: "1rem",
              }}
            ></div>
            <MobileViewData data={data} />
          </div>
        </div>
  
  );
}

export default MobileView;
